import Logo1 from '../../Assets/img/Logos/clients/Abee Research.png';
import Logo2 from '../../Assets/img/Logos/clients/eclinical.png';
import Logo3 from '../../Assets/img/Logos/clients/Flowedge Logo.png';
import Logo4 from '../../Assets/img/Logos/clients/IFHD Logo.png';
import Logo5 from '../../Assets/img/Logos/clients/Intensaquatica logo.png';
import Logo6 from '../../Assets/img/Logos/clients/Intercax.jpg';
import Logo7 from '../../Assets/img/Logos/clients/Plivo Logo.png';
import Logo8 from '../../Assets/img/Logos/clients/Puma Logo.png';
import Logo9 from '../../Assets/img/Logos/clients/Srijan Capital Advisors LLP Logo.png';
import Logo10 from '../../Assets/img/Logos/clients/Srushti Pharma Logo.jpg';
import Logo11 from '../../Assets/img/Logos/clients/Tardid Logo.JPG';
import Logo12 from '../../Assets/img/Logos/clients/tga.webp';

let clients = [
  {
    logo: Logo1,
    websiteLink:
      'https://www.cdcgroup.com/en/our-impact/underlying/abee-research-labs-p-lts-switchon/',
  },
  {
    logo: Logo2,
    websiteLink: 'https://www.eclinicalworks.com/',
  },
  {
    websiteLink: 'http://flowedge.co/',
    logo: Logo3,
  },
  {
    websiteLink: 'http://ifhd.in/',
    logo: Logo4,
  },
  {
    websiteLink: 'https://www.intensaquatica.com/',
    logo: Logo5,
  },
  {
    logo: Logo6,
    websiteLink: 'https://intercax.com/',
  },
  {
    websiteLink: 'https://www.plivo.com/',
    logo: Logo7,
  },
  {
    websiteLink: 'https://us.puma.com/',
    logo: Logo8,
  },
  {
    websiteLink: 'http://www.srijancapital.com/',
    logo: Logo9,
  },
  {
    websiteLink: 'http://www.srushtipharma.com/',
    logo: Logo10,
  },
  {
    websiteLink: 'https://www.tardidtech.com/brainbox-platform-knowhere',
    logo: Logo11,
  },
  {
    websiteLink: 'https://lms.thegateacademy.com/dashboard',
    logo: Logo12,
  },
];

export default clients;
